import {
  DeleteTwoTone,
  DownloadOutlined,
  LoadingOutlined,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  FormInstance,
  Input,
  InputNumber,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
  Spin,
  Table,
  TableColumnsType,
  TreeSelect,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { useTheme } from "../../Context/ThemeContext";
import { useClient } from "../../Context/ClientContext";
import * as XLSX from "xlsx";
import LedgerService, {
  GSTTax_Type,
  ImportLedgerAddType,
  NewCompanyGstType_new,
  PartyType,
  SearchLedgerByGroupsTypes,
  TypeOfAddress,
} from "../../Services/LedgerService";
import { dayjs } from "../../../Utilities/dayjs";
import { AssetStatus } from "../../Services/FixedAssetsServiceNew";
import { AssetPurType, CalcMethod } from "../Assets/AssetModel";
import { BusinessTypes } from "../../Services/ChartofAccountServicesNew";
import {
  BankAccountTypes,
  BusinessNatures,
  DeducteeTypes,
  getTDSDeducteeTypeName,
} from "../../Services/ClientService";
import { CompanyGSTTypes, IndianStates } from "../../../Types/CommonConstants";
import { useLocation } from "react-router-dom";
import { Rule } from "antd/es/form";
import ReportsServiceNew, {
  GroupList_Type,
} from "../../Services/ReportsServiceNew";
import { useUser } from "../../../Context/UserContext";
import {
  allCountriesStates,
  countryOptionsOnlyIndia,
  countryOptionsWithOutIndia,
} from "../../../Types/CommonAllCountriesStates";
import {
  BusinessNaturesTypeOptions,
  BusinessTypeOptions,
  GSTTypeOptions,
} from "../Clients/Clients";
import { Utils } from "../../../Utilities/Utils";

interface IProps {
  onCancel: any;
  selType?: string;
  setImportedPartyList?: any;
  // setImportList : (data:any[]) => void
}
type ParsedDataType = {
  [key: string]: any;
};

interface Item {
  key: string;
  name: string;
  age: number;
  gender: string;
  dob?: string;
}
interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  rowKey: any;
  inputType: string;
  form: FormInstance;
  required?: boolean;
}

const ImportPartyModal = (props: IProps) => {
  const { currentClient, companySettings } = useClient();
  const { themeData } = useTheme();
  const location = useLocation();
  const [load, setLoad] = useState<boolean>(false);
  const [headerData, setHeaderData] = useState<any>([]);
  const [showHeaderData, setShowHeaderData] = useState<any>([]);
  const [forData, setForData] = useState<any>([]);
  const [result, setResult] = useState<any>();
  const [ledgerCount, setLedgerCount] = useState<number>(0);
  const [addLedName, setAddLedName] = useState<number>(0);
  const [denLedName, setDenLedName] = useState<number>(0);
  const [exiLedName, setExiLedName] = useState<number>(0);
  const [form] = Form.useForm();
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [groupDropdownloading, setGroupDropdownLoading] = React.useState(true);
  const [groupData, setGroupData] = useState<any[]>([]);

  const [gSTTypeValue, setGSTTypeValue] = useState<
    Record<number, { GSTType: number }>
  >({});
  // const [ccViewDetails, setCCViewDetails] = useState<boolean>(false);
  // const [selectCountry, setSelectCountry] = useState<string[]>([]);
  const { getAllIndStates } = useUser();
  const stateOptions: any = getAllIndStates();
  const dataSource = [
    {
      key: "1",
      name: "Basic detail",
      required: "",
      notes: "",
      subtitle: true,
    },
    {
      key: "2",
      name: "LedgerName",
      required: "YES",
      notes: (
        <>
          1. Only alphanumeric with space and some special characters i.e. '_',
          '(', ')', '&', '-', '.' and ',' are allowed.
          <br />
          2. Length must be Minimum 3 or Maximum 80 characters long.
        </>
      ),
    },
    // {
    //   key: "3",
    //   name: "Amount",
    //   required: "",
    //   notes:
    //     "Use this field for statements which provide single column for money-in and money-out.",
    // },
    {
      key: "4",
      name: "AliasName",
      required: "",
      notes: (
        <>
          1. Only alphanumeric with space and some special characters i.e. '_',
          '(', ')', '&', '-', '.' and ',' are allowed. <br />
          2. Length must be Minimum 3 or Maximum 20 characters long.
        </>
      ),
    },
    {
      key: "5",
      name: "Parent_Group",
      required: "YES",
      notes: "Selection of parent group is mandatory.",
    },
    // {
    //   key: "6",
    //   name: "BankLedgerName",
    //   required: "",
    //   notes: "Enter the BankLedgerName",
    // },
    {
      key: "6",
      name: "Bank detail (in case Parent group is bank type or party type group)",
      required: "",
      notes: "",
      subtitle: true,
    },

    {
      key: "8",
      name: "AccountHolderName",
      required: "",
      notes: (
        <>
          1. Only alphanumeric with space and some special characters i.e. '_',
          '(', ')', '&', '-', '.' and ',' are allowed. <br />
          2. Length must be Minimum 3 or Maximum 80 characters long.
        </>
      ),
    },
    {
      key: "9",
      name: "AccountNumber",
      required: "",
      notes: (
        <>
          1. Enter valid account number in digits.
          <br />
          2. Length must be Minimum 6 or Maximum 18 characters long.
        </>
      ),
    },
    {
      key: "10",
      name: "AccountType",
      required: "",
      notes: "Select the appropriate Account Type.",
    },
    {
      key: "11",
      name: "BankName",
      required: "",
      notes: (
        <>
          1. Only alphanumeric with space and some special characters i.e. '_',
          '(', ')', '&', '-', '.' and ',' are allowed. <br />
          2. Length must be Minimum 3 or Maximum 80 characters long.
        </>
      ),
    },
    {
      key: "12",
      name: "IFSCode",
      required: "",
      notes: "Enter valid 11 alphanumeric IFS code.",
    },
    {
      key: "13",
      name: "Branch",
      required: "",
      notes:
        "Enter the branch name. Length must be Minimum 3 or Maximum 50 characters long.",
    },
    {
      key: "14",
      name: "ODLimit",
      required: "",
      notes: "Enter the limit in amount.",
    },
    {
      key: "7",
      name: "UPIId",
      required: "",
      notes: "Enter the valid UPIId",
    },

    {
      key: "15",
      name: "BankIsDefault",
      required: "",
      notes: "Select true or false.",
    },
    // {
    //   key: "16",
    //   name: "TypeOfDuty",
    //   required: "Yes",
    //   notes: "Select the type of duty.",
    // },
    // {
    //   key: "17",
    //   name: "GSTTaxType",
    //   required: "YES",
    //   notes: "Select the GST tax type if type of duty is GST.",
    // },
    // {
    //   key: "18",
    //   name: "GSTRate",
    //   required: "YES",
    //   notes: "Select the GST Rate Detail",
    // },
    {
      key: "18",
      name: "Party detail",
      required: "",
      notes: "",
      subtitle: true,
    },

    {
      key: "19",
      name: "Add1Type",
      required: "",
      notes: "Select the address type.",
    },
    {
      key: "20",
      name: "Add1Name",
      required: "YES",
      notes: (
        <>
          1. Only alphabets with space and some special characters i.e. '(', ')'
          and '&' are allowed. <br />
          2. Length must be Minimum 3 or Maximum 30 characters long.
        </>
      ),
    },
    {
      key: "21",
      name: "Add1Building",
      required: "",
      notes: "Maximum 150 characters are allowed.",
    },
    {
      key: "22",
      name: "Add1Street",
      required: "",
      notes: "Maximum 150 characters are allowed.",
    },
    {
      key: "23",
      name: "Add1Landmark",
      required: "",
      notes: "Maximum 150 characters are allowed.",
    },
    {
      key: "24",
      name: "Add1City",
      required: "",
      notes: (
        <>
          1. Only alphabets with space and some special characters i.e. '(', ')'
          and '&' are allowed. <br />
          2. Length must be Minimum 3 or Maximum 30 characters.
        </>
      ),
    },
    {
      key: "25",
      name: "Add1District",
      required: "",
      notes: (
        <>
          1. Only alphabets with space and some special characters i.e. '(', ')'
          and '&' are allowed. <br />
          2. Length must be Minimum 3 or Maximum 30 characters.
        </>
      ),
    },
    {
      key: "26",
      name: "Add1Pincode",
      required: "",
      notes: "Enter valid 6 digit Pincode.",
    },
    {
      key: "27",
      name: "Add1State",
      required: "YES",
      notes: "Select the appropriate State.",
    },
    {
      key: "28",
      name: "Add1Country",
      required: "",
      notes: "Enter the Country name.",
    },
    {
      key: "29",
      name: "Add2Type",
      required: "",
      notes: "Select the address type.",
    },
    {
      key: "30",
      name: "Add2Name",
      required: "",
      notes: (
        <>
          1. Only alphabets with space and some special characters i.e. '(', ')'
          and '&' are allowed. <br />
          2. Length must be Minimum 3 or Maximum 30 characters long.
        </>
      ),
    },
    {
      key: "31",
      name: "Add2Building",
      required: "",
      notes: "Maximum 150 characters are allowed.",
    },
    {
      key: "32",
      name: "Add2Street",
      required: "",
      notes: "Maximum 150 characters are allowed.",
    },
    {
      key: "33",
      name: "Add2Landmark",
      required: "",
      notes: "Maximum 150 characters are allowed.",
    },
    {
      key: "34",
      name: "Add2City",
      required: "",
      notes: (
        <>
          1. Only alphabets with space and some special characters i.e. '(', ')'
          and '&' are allowed. <br />
          2. Length must be Minimum 3 or Maximum 30 characters.
        </>
      ),
    },
    {
      key: "35",
      name: "Add2District",
      required: "",
      notes: (
        <>
          1. Only alphabets with space and some special characters i.e. '(', ')'
          and '&' are allowed. <br />
          2. Length must be Minimum 3 or Maximum 30 characters.
        </>
      ),
    },
    {
      key: "36",
      name: "Add2Pincode",
      required: "",
      notes: "Enter valid 6 digit Pincode.",
    },
    {
      key: "37",
      name: "Add2State",
      required: "",
      notes: "Select the appropriate State.",
    },
    {
      key: "38",
      name: "Add2Country",
      required: "",
      notes: "Enter the Country name.",
    },
    {
      key: "40",
      name: "CreditPeriod",
      required: "",
      notes: "Enter the credit period in days.",
    },
    {
      key: "41",
      name: "CreditLimit",
      required: "",
      notes: "Enter the credit limit amount.",
    },
    {
      key: "42",
      name: "Name",
      required: "",
      notes: (
        <>
          1. Only alphanumeric with space and some special characters i.e. '_',
          '(', ')', '&' and '-' are allowed. <br />
          2. Length must be minimum 3 or maximum 30 characters.
        </>
      ),
    },
    {
      key: "43",
      name: "Designation",
      required: "",
      notes: (
        <>
          1. Only alphanumeric with space and some special characters i.e. '_',
          '(', ')', '&' and '-' are allowed. <br />
          2. Length must be minimum 3 or maximum 30 characters.
        </>
      ),
    },
    {
      key: "44",
      name: "Phone",
      required: "",
      notes: "Length must be 10 digits long.",
    },
    {
      key: "45",
      name: "Email",
      required: "",
      notes:
        "Enter a valid email address and length must be minimum 10 or maximum 80 characters long.",
    },
    {
      key: "46",
      name: "CCTo",
      required: "",
      notes:
        "Enter the valid email address(es) and length must be minimum 10 or maximum 250 characters long.",
    },
    {
      key: "47",
      name: "IsDefault",
      required: "",
      notes: "Select true or false.",
    },
    {
      key: "",
      name: "Business detail (only in case of company, firm, etc.)",
      required: "",
      notes: "",
      subtitle: true,
    },

    {
      key: "48",
      name: "BusinessType",
      required: "",
      notes: "Select the business type.",
    },
    {
      key: "49",
      name: "BusinessNature",
      required: "",
      notes: "Select the nature of the business.",
    },
    {
      key: "50",
      name: "MSMENo",
      required: "",
      notes: "Enter the MSME No, if have.",
    },
    {
      key: "51",
      name: "Website",
      required: "",
      notes: "Enter the website url of the business.",
    },
    {
      key: "52",
      name: "GSTType",
      required: "",
      notes: "Select the GST Type like Regular or Unregistered.",
    },
    {
      key: "53",
      name: "GSTIN",
      required: "YES",
      notes: "Enter the GST No. if business is GST registered.",
    },
    {
      key: "54",
      name: "PAN",
      required: "YES",
      notes: "Enter the PAN No. of the business.",
    },
    {
      key: "55",
      name: "State",
      required: "Yes",
      notes: "Select the State name.",
    },
    {
      key: "56",
      name: "TAN",
      required: "",
      notes: "Enter the TAN No. of the business.",
    },
    {
      key: "57",
      name: "IEC",
      required: "",
      notes: "Enter the import export code (IEC) of the business, if have any.",
    },
    {
      key: "58",
      name: "TDSDeductible",
      required: "",
      notes: "Select if business deduct the TDS.",
    },
    {
      key: "59",
      name: "TDSDeducteeType",
      required: "",
      notes: "Select the TDS Deductee Type if business deducts the TDS.",
    },
    {
      key: "60",
      name: "DeductTDSinSameVoucher",
      required: "",
      notes: "Select if you want to deduct the TDS in same voucher.",
    },
    {
      key: "61",
      name: "LedgerTCSApplicability",
      required: "",
      notes: "Select if business collect the TCS.",
    },
    {
      key: "62",
      name: "TCSCollecteeType",
      required: "",
      notes: "Select the TCS Collectee Type if business collects the TCS.",
    },
    {
      key: "63",
      name: "PartyDisRate",
      required: "",
      notes: "Enter the discount rate applied to specific party.",
    },
    {
      key: "64",
      name: "In case of Creditors only",
      required: "",
      notes: "",
      subtitle: true,
    },
    {
      key: "65",
      name: "IsTransporter",
      required: "",
      notes: "Select if party is transporter.",
    },
  ];

  const columns: TableColumnsType<any> = [
    {
      title: "Field Name",
      dataIndex: "name",
      key: "name",
      width: "20%",
      render: (text, record) => (record.subtitle ? <u>{text}</u> : <>{text}</>),
      onCell: (record, index) => ({
        colSpan: record?.subtitle ? 3 : 1,
      }),
    },
    {
      title: "Required",
      dataIndex: "required",
      key: "require",
      width: "10%",
      onCell: (record, index) => ({
        colSpan: record?.subtitle ? 0 : 1,
      }),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      onCell: (record, index) => ({
        colSpan: record?.subtitle ? 0 : 1,
      }),
    },
  ];

  const getListData = async () => {
    await ReportsServiceNew.getGroupHierarchy(
      currentClient?.id!,
      undefined,
      undefined,
      "",
      GroupList_Type.All,
      SearchLedgerByGroupsTypes.PartiesOnly
    )
      .then((res: any) => {
        let index = 0;
        const dataSetInApi = (allgroupList: any[]) => {
          return allgroupList.map((x: any) => {
            const node: any = {
              id: x?.id,
              parent: x?.parent,
              value: x?.id,
              title: x?.name,
              nature: x?.nature,
              statement: x?.statement,
            };
            if (x?.children?.length > 0) {
              node.children = dataSetInApi(x?.children);
            }
            return node;
          });
        };

        const flattenedData = dataSetInApi(res?.groupList);
        setGroupData(flattenedData);
        console.log("GroupData", flattenedData);
        setGroupDropdownLoading(false);
      })
      .catch((err: any) => {
        setGroupData([]);
      });
  };
  useEffect(() => {
    getListData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const DeducteeTypesOptions = Object.keys(DeducteeTypes)
    .filter((type) => !isNaN(Number(type)))
    .map((type: any) => {
      return {
        key: Number(type),
        label: getTDSDeducteeTypeName(type),
        value: Number(type),
      };
    });

  console.log("gSTTypeValue : ", gSTTypeValue);

  const getValidationRules = (
    inputType: string,
    title: any,
    rowKey: any
  ): Rule[] => {
    switch (inputType) {
      case "LedgerName":
        return [
          { required: true, message: `${title} is required.` },
          {
            pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
            message:
              "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
          },
          {
            min: 3,
            max: 80,
            message: "Length must be Minimum 3 or Maximum 80 characters long",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();

              const list = form.getFieldValue("list") || {};
              const Value = value.trim().toLowerCase();

              // const entries = Object.entries(list);
              const duplicates = Object.entries(list).filter(
                ([_, obj]: any) =>
                  obj?.LedgerName?.trim().toLowerCase() === Value
              );
              if (duplicates.length > 1) {
                return Promise.reject(
                  new Error("Duplicate LedgerName not allowed")
                );
              }
              return Promise.resolve();
            },
          },
        ];
      case "AliasName":
        return [
          {
            pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
            message:
              "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
          },
          {
            min: 3,
            max: 20,
            message: "Length must be Minimum 3 or Maximum 80 characters long",
          },
        ];
      case "Add1Name":
        // case "Add2AddressName":
        return [
          { required: true, message: `${title} is required.` },
          {
            pattern: /^[A-Za-z][ A-Za-z()&]*$/,
            message:
              "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
          },
          {
            min: 2,
            max: 20,
            message: "Length must be Minimum 2 or Maximum 20 characters long",
          },
        ];
      case "Add1Building":
      case "Add1Street":
      case "Add1Landmark":
      case "Add2Building":
      case "Add2Street":
      case "Add2Landmark":
        return [{ max: 150, message: "Maximum 150 characters are allowed" }];
      case "Add1City":
      case "Add1District":
      case "Add2City":
      case "Add2District":
        return [
          {
            pattern: /^[A-Za-z][ A-Za-z()&]*$/,
            message:
              "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
          },
          {
            min: 3,
            max: 30,
            message: "Length must be Minimum 3 or Maximum 30 characters",
          },
        ];
      case "Add1State":
        // case "Add2State":
        return [
          {
            required:
              gSTTypeValue[rowKey]?.GSTType === CompanyGSTTypes.Unregistered ||
              gSTTypeValue[rowKey]?.GSTType === CompanyGSTTypes.Consumer
                ? true
                : false,
            message: "Please select the State",
          },
        ];
      case "Add1Pincode":
      case "Add2Pincode":
        return [
          {
            pattern: /^\d{6}$/,
            message: "Please enter valid 6 digit Pincode",
          },
          // { min: 6, max: 6, message: "Length must be 6 digits long" },
        ];
      case "Phone":
        return [
          { pattern: /^[6-9]{1}[0-9]{9}$/, message: "Enter valid Phone No." },
          // { min: 10, max: 10, message: "Length must be 10 digits long" },
        ];
      case "Email":
        return [
          { type: "email", message: "Enter valid email address" },
          {
            min: 10,
            max: 80,
            message: "Length must be Minimum 10 or Maximum 80 characters",
          },
        ];
      case "CCTo":
        return [
          { type: "email", message: "Enter valid email address" },
          {
            min: 10,
            max: 250,
            message: "Length must be Minimum 10 or Maximum 250 characters",
          },
        ];
      case "Name":
      case "Designation":
        return [
          {
            pattern: /^[A-Za-z][ A-Za-z0-9_()&-]*$/,
            message:
              "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&' and '-' are allowed",
          },
          {
            min: 3,
            max: 30,
            message: "Length must be Minimum 3 or Maximum 30 characters",
          },
        ];
      case "Website":
        return [
          { type: "url", message: "Please enter a valid URL" },
          {
            min: 10,
            max: 50,
            message:
              "Please enter a valid URL having minimum 10 or maximum 50 length",
          },
        ];
      case "CreditPeriod":
        return [
          { pattern: /^[0-9]+$/, message: "Credit period must be numeric" },
        ];
      case "CreditLimit":
        return [
          { pattern: /^[0-9]+$/, message: "Credit limit must be numeric" },
        ];
      case "State":
        return [
          {
            required:
              gSTTypeValue[rowKey]?.GSTType === CompanyGSTTypes.Unregistered
                ? true
                : false,
            message: "Please select the State",
          },
        ];
      case "PAN":
        return [
          {
            pattern: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
            message: "Enter valid 10 alphanumeric PAN number",
          },
          { min: 10, max: 10, message: "PAN No. must be 10 characters long" },
        ];
      case "GSTIN":
        return [
          {
            required:
              gSTTypeValue[rowKey]?.GSTType === CompanyGSTTypes.Unregistered ||
              gSTTypeValue[rowKey]?.GSTType === CompanyGSTTypes.Consumer
                ? false
                : true,
            message: "GST number is required",
          },
          {
            pattern:
              /^(?!00)[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}Z[0-9A-Za-z]{1}$/,
            message: "Enter valid 15 alphanumeric GST number",
          },
        ];
      case "TAN":
        return [
          {
            pattern: /^[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}$/,
            message: "Enter valid 10 alphanumeric TAN number",
          },
          { min: 10, max: 10, message: "Length must be 10 characters long" },
        ];
      case "IEC":
        return [
          {
            pattern: /^[A-Za-z0-9]{10}$/,
            message: "Enter valid 10 alphanumeric IEC number",
          },
          { min: 10, max: 10, message: "Length must be 10 characters long" },
        ];
      case "MSMENo":
        return [
          {
            pattern: /^(?!.*-000-)(?!.*-0{7}$)^[A-Za-z]{2}-[0]{2}-[0-9]{7}$/,
            message: "Enter valid 19 digit MSME No. including '-'",
          },
        ];
      case "AccountHolderName":
      case "BankName":
        return [
          {
            pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
            message:
              "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
          },
          {
            min: 3,
            max: 80,
            message: "Length must be Minimum 3 or Maximum 80 characters long",
          },
        ];
      case "AccountNumber":
        return [
          {
            pattern: /^(?!0+$)\d{6,18}$/,
            message:
              "Enter valid account number in digits with minimum 6 and maximum 18 length",
          },
        ];
      case "IFSCode":
        return [
          {
            pattern: /^[A-Za-z]{4}[0][0-9]{6}$/,
            message: "Input valid 11 alphanumeric IFSC code",
          },
          { min: 11, max: 11, message: "Length must be 11 characters long" },
        ];
      case "Branch":
        return [
          {
            pattern: /^[A-Za-z][ A-Za-z]*$/,
            message: "Enter valid branch's name",
          },
          {
            min: 3,
            max: 50,
            message: "Length must be Minimum 3 or Maximum 50 characters long",
          },
        ];
      case "UPIId":
        return [
          {
            pattern: /^[a-zA-Z0-9.\-_]{2,40}@[a-zA-Z]{2,20}$/,
            message: "Please enter a valid UPI Id",
          },
          {
            min: 3,
            max: 45,
            message: "Length must be Minimum 3 or Maximum 45 characters long",
          },
        ];

      case "Add1Type":
      case "Add2Type":
      case "TDSDeducteeType":
      case "TCSCollecteeType":
      case "DeductTDSinSameVoucher":
      case "TDSDeductible":
      case "LedgerTCSApplicability":
      case "BankIsDefault":
      case "IsTransporter":
      case "ODLimit":
      case "IsDefault":
        return [
          {
            required: false,
          },
        ];

      default:
        return [{ required: false, message: `${title} is required.` }];
    }
  };

  const getInput = (inputType: any, rowkey?: any) => {
    switch (inputType) {
      case "LedgerName":
        return (
          <Input
            autoFocus
            placeholder={`${"Ledger"} name`}
            onChange={() => {
              const list = form.getFieldValue("list") || {};
              Object.keys(list).forEach((key) => {
                if (key !== rowkey?.toString()) {
                  form.validateFields([["list", key, "LedgerName"]]);
                }
              });

              console.log("form list ", list);
            }}
          />
        );
      case "AliasName":
        return (
          <Input
            style={{ width: "100%" }}
            onInput={(e: any) =>
              (e.target.value =
                e.target.value.length > 1
                  ? e.target.value
                  : e.target.value.toUpperCase())
            }
          />
        );
      case "Add1Building":
      case "Add1Street":
      case "Add1Landmark":
      case "Add2Building":
      case "Add2Street":
      case "Add2Landmark":
        return <Input style={{ width: "100%" }} maxLength={150} />;

      case "Parent_Group":
        return (
          <TreeSelect
            showSearch
            virtual={false}
            style={{ width: "100%" }}
            labelInValue
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            placeholder="Please select Group"
            treeDefaultExpandAll
            treeData={groupDropdownloading ? [] : groupData}
            treeNodeLabelProp="title"
            fieldNames={{
              label: "title",
              value: "value",
              children: "children",
            }}
            treeNodeFilterProp="title"
          />
        );
      case "Add1Type":
      case "Add2Type":
        return (
          <Select
            placeholder="Type"
            defaultValue={() => TypeOfAddress.RegisteredAddress}
            options={[
              {
                label: "Registered Address",
                value: TypeOfAddress.RegisteredAddress,
              },
              {
                label: "Business Address",
                value: TypeOfAddress.BusinessAddress,
              },
              {
                label: "Branch Address",
                value: TypeOfAddress.BranchAddress,
              },
              {
                label: "Unit Address",
                value: TypeOfAddress.UnitAddress,
              },
              {
                label: "Godown Address",
                value: TypeOfAddress.GodownAddress,
              },
            ]}
            style={{
              width: window.innerWidth <= 425 ? "226px" : " ",
            }}
          />
        );
      case "Add1City":
      case "Add1District":
      case "Add2City":
      case "Add2District":
        return <Input style={{ width: "100%" }} minLength={3} maxLength={30} />;
      case "Add1Pincode":
      case "Add2Pincode":
        return (
          <Input
            style={{ width: "100%" }}
            minLength={6}
            maxLength={6}
            onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
          />
        );
      case "Add1State":
      case "Add2State":
        return (
          <>
            {gSTTypeValue[rowkey]?.GSTType !== CompanyGSTTypes.Overseas ? (
              <Select
                showSearch
                placeholder="State"
                options={Object.entries(stateOptions)?.map(([key, x]: any) => ({
                  value: x?.id,
                  label: x?.name,
                }))}
                filterOption={(input, option) =>
                  (option?.label.toString() ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            ) : (
              <Select showSearch placeholder="State" disabled />
            )}
          </>
        );
      case "Add1Country":
      case "Add2Country":
        return (
          <Select
            showSearch
            placeholder="Country"
            options={
              gSTTypeValue[rowkey]?.GSTType === CompanyGSTTypes.Overseas
                ? countryOptionsWithOutIndia
                : countryOptionsOnlyIndia
            }
            allowClear
            filterOption={(input, option) =>
              (option?.label.toString() ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            style={{
              width: window.innerWidth <= 425 ? "226px" : " ",
            }}
          />
        );
      case "CreditPeriod":
        return (
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            max={365}
            controls={false}
            onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
          />
        );
      case "CreditLimit":
        return (
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            max={999999999}
            controls={false}
            onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
          />
        );
      case "Name":
      case "Designation":
        return <Input style={{ width: "100%" }} minLength={3} maxLength={30} />;

      case "Phone":
        return (
          <Input
            style={{ width: "100%" }}
            minLength={10}
            maxLength={10}
            onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
          />
        );

      case "Email":
        return (
          <Input style={{ width: "100%" }} minLength={10} maxLength={80} />
        );

      case "CCTo":
        return (
          <Input style={{ width: "100%" }} minLength={10} maxLength={250} />
        );

      case "TDSDeductible":
      case "DeductTDSinSameVoucher":
      case "LedgerTCSApplicability":
      case "IsDefault":
      case "BankIsDefault":
      case "IsTransporter":
        return <Checkbox />;

      case "BusinessType":
        return (
          <Select
            style={{ width: "100%" }}
            allowClear
            showSearch
            options={BusinessTypeOptions}
            filterOption={(input, option) =>
              (option?.label.toString() ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        );

      case "BusinessNature":
        return (
          <Select
            style={{ width: "100%" }}
            mode="multiple"
            showSearch={false}
            options={BusinessNaturesTypeOptions}
          />
        );

      case "MSMENo":
        return (
          <Input
            style={{ width: "100%" }}
            addonBefore="UDYAM-"
            placeholder="XX-00-0123456"
            minLength={13}
            maxLength={13}
          />
        );
      case "State":
        return (
          <Select
            disabled={
              gSTTypeValue[rowkey]?.GSTType === CompanyGSTTypes.Regular ||
              gSTTypeValue[rowkey]?.GSTType === CompanyGSTTypes.Composition ||
              gSTTypeValue[rowkey]?.GSTType === CompanyGSTTypes.SEZ ||
              gSTTypeValue[rowkey]?.GSTType ===
                CompanyGSTTypes.DeemedExportImport
                ? true
                : false
            }
            showSearch
            placeholder="State"
            options={Object.entries(stateOptions)?.map(([key, x]: any) => ({
              value: x?.id,
              label: x?.name,
            }))}
            filterOption={(input, option) =>
              (option?.label.toString() ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            style={{
              width: window.innerWidth <= 425 ? "226px" : " ",
            }}
          />
        );
      case "Website":
        return (
          <Input
            style={{ width: "100%" }}
            minLength={10}
            maxLength={50}
            placeholder="https://www.example.com"
          />
        );
      case "GSTType":
        return (
          <Select
            options={GSTTypeOptions}
            onChange={(value) => {
              setGSTTypeValue((prev) => ({
                ...prev,
                [rowkey]: {
                  GSTType: value ?? CompanyGSTTypes.Unregistered,
                },
              }));
              switch (value) {
                case CompanyGSTTypes.Unregistered:
                  form.setFieldValue(["list", rowkey, "GSTIN"], "");
                  break;
                case CompanyGSTTypes.Consumer:
                  form.setFieldValue(["list", rowkey, "PAN"], "");
                  form.setFieldValue(["list", rowkey, "State"], null);
                  break;
                default:
                  break;
              }
            }}
          />
        );
      case "GSTIN":
        return (
          <Input
            maxLength={15}
            minLength={15}
            placeholder="00AABCC1234D1ZZ"
            allowClear={true}
            onInput={(e: any) =>
              (e.target.value = e.target.value.toUpperCase())
            }
            disabled={
              gSTTypeValue[rowkey]?.GSTType === CompanyGSTTypes.Unregistered ||
              gSTTypeValue[rowkey]?.GSTType === CompanyGSTTypes.Consumer
                ? true
                : false
            }
          />
        );
      case "PAN":
        return (
          <Input
            disabled={
              gSTTypeValue[rowkey]?.GSTType === CompanyGSTTypes.Regular ||
              gSTTypeValue[rowkey]?.GSTType === CompanyGSTTypes.Composition ||
              gSTTypeValue[rowkey]?.GSTType === CompanyGSTTypes.SEZ ||
              gSTTypeValue[rowkey]?.GSTType ===
                CompanyGSTTypes.DeemedExportImport
                ? true
                : false
            }
            maxLength={10}
            minLength={10}
            placeholder="AABCC1234D"
            onInput={(e: any) =>
              (e.target.value = e.target.value.toUpperCase())
            }
          />
        );

      case "TAN":
        return (
          <Input
            style={{ width: "100%" }}
            placeholder="AAAA99999A"
            minLength={10}
            maxLength={10}
          />
        );

      case "IEC":
        return (
          <Input
            style={{ width: "100%" }}
            placeholder="IEC Code"
            minLength={10}
            maxLength={10}
          />
        );

      case "TDSDeducteeType":
      case "TCSCollecteeType":
        return (
          <Select style={{ width: "100%" }} options={DeducteeTypesOptions} />
        );

      case "AccountHolderName":
      case "BankName":
        return <Input style={{ width: "100%" }} minLength={3} maxLength={80} />;

      case "AccountNumber":
        return <Input style={{ width: "100%" }} minLength={6} maxLength={18} />;

      case "AccountType":
        return (
          <Select
            style={{ width: "100%" }}
            placeholder="Account type"
            options={[
              {
                label: "Cash Credit Account",
                value: BankAccountTypes.CashCreditAccount,
              },
              {
                label: "Overdraft Account",
                value: BankAccountTypes.OverdraftAccount,
              },
              {
                label: "Credit Card Account",
                value: BankAccountTypes.CreditCard,
              },

              {
                label: "Saving Account",
                value: BankAccountTypes.SavingAccount,
              },
              {
                label: "Current Account",
                value: BankAccountTypes.CurrentAccount,
              },
            ]}
          />
        );

      case "IFSCode":
        return (
          <Input
            style={{ width: "100%" }}
            placeholder="BANK0123456"
            maxLength={11}
            minLength={11}
            onInput={(e: any) =>
              (e.target.value = e.target.value.toUpperCase())
            }
          />
        );
      case "Branch":
        return <Input style={{ width: "100%" }} minLength={3} maxLength={50} />;

      case "ODLimit":
        return (
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            max={999999999}
            controls={false}
          />
        );

      case "UPIId":
        return <Input style={{ width: "100%" }} minLength={3} maxLength={45} />;

      default:
        return <Input style={{ width: "100%" }} />;
    }
  };

  const EditableCell: React.FC<EditableCellProps> = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    inputType,
    form,
    rowKey,
    ...restProps
  }) => {
    let childNode = children;

    if (editable) {
      const other = [
        "TDSDeductible",
        "DeductTDSinSameVoucher",
        "LedgerTCSApplicability",
        "IsDefault",
        "BankIsDefault",
        "IsTransporter",
      ].includes(inputType)
        ? {
            valuePropName: "checked",
          }
        : {};
      childNode = (
        <Form.Item
          {...other}
          style={{ margin: 0 }}
          name={["list", rowKey, inputType]}
          rules={getValidationRules(inputType, title, rowKey)}
        >
          {getInput(inputType, rowKey)}
        </Form.Item>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  };

  const handleDownload = () => {
    const fileUrl =
      location.pathname.split("/")[4] === "expensesLedger"
        ? `${process.env.PUBLIC_URL}/Docs/ExpensesMaster.xlsx`
        : location.pathname.split("/")[4] === "incomeLedger"
        ? `${process.env.PUBLIC_URL}/Docs/IncomeMaster.xlsx`
        : location.pathname.split("/")[4] === "sales"
        ? `${process.env.PUBLIC_URL}/Docs/CustomersMaster.xlsx`
        : location.pathname.split("/")[4] === "purchase"
        ? `${process.env.PUBLIC_URL}/Docs/SuppliersMaster.xlsx`
        : `${process.env.PUBLIC_URL}/Docs/PartyMaster.xlsx`;
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download =
      location.pathname.split("/")[4] === "expensesLedger"
        ? `ExpensesMaster.xlsx`
        : location.pathname.split("/")[4] === "incomeLedger"
        ? `IncomeMaster.xlsx`
        : location.pathname.split("/")[4] === "sales"
        ? `CustomersMaster.xlsx`
        : location.pathname.split("/")[4] === "purchase"
        ? `SuppliersMaster.xlsx`
        : location.pathname.split("/")[5] === "openingBalance" &&
          props.selType === "Customer"
        ? `CustomersMaster.xlsx`
        : location.pathname.split("/")[5] === "openingBalance" &&
          props.selType === "Supplier"
        ? `SuppliersMaster.xlsx`
        : `PartyMaster.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDelete = (key: React.Key) => {
    setForData((prev: any) => prev.filter((item: any) => item.key !== key));
  };
  console.log("showHeaderData: ", showHeaderData);

  const columnsSec: TableColumnsType<any> = headerData
    ?.filter((field: string) => field !== "Parent_Id")
    ?.map((field: string, index: number) => ({
      title: showHeaderData[index],
      dataIndex: index,
      key: index + 1,
      editable: true,
      fixed: index < 3 ? "left" : undefined,
      inputType: field,
    }));

  columnsSec.unshift({
    title: "Action",
    dataIndex: 0,
    key: 0,
    fixed: "left",
    width: 10,
    render: (_, record) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => handleDelete(record?.key)}
        >
          <Button
            style={{
              padding: "0px",
              borderColor: "#fff",
              boxShadow: "none",
            }}
          >
            <DeleteTwoTone className="ca-delete-btn" twoToneColor="#ff879d" />
          </Button>
        </Popconfirm>
      </div>
    ),
  });

  columnsSec.unshift({
    title: "Result",
    dataIndex: "result",
    key: "result",
    fixed: "left",
    render: (_: any, record: any, index: number) => {
      const res = result?.[index]?.added;
      return res === ImportLedgerAddType.Added ? (
        <span style={{ color: "green" }}>Imported</span>
      ) : res === ImportLedgerAddType.Denied ? (
        <span style={{ color: "red" }}>{result?.[index]?.erroemessage}</span>
      ) : (
        <span
          style={{ color: ImportLedgerAddType[res] ? "rgb(250, 173, 20)" : "" }}
        >
          {ImportLedgerAddType[res] || "No Data"}
        </span>
      );
    },
  });

  // data.unshift({
  //   result,
  // });

  console.log("headerData befor slice : ", headerData);

  const mergedColumns = columnsSec?.map((col: any, index: number) => {
    if (!col?.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        editable: col?.editable,
        dataIndex: index,
        title: col?.title,
        inputType: col?.inputType,
        rowKey: record?.key,
        form,
      }),
    };
  });

  console.log("mergedColumns befor slice : ", mergedColumns);

  const AddFromIndex = headerData.indexOf("Add1Type") + 1;
  const PayTermsFromIndex = headerData.indexOf("CreditPeriod") + 1;
  const NameFromIndex = headerData.indexOf("Name") + 1;
  const BusinessDFromIndex = headerData.indexOf("BusinessType") + 1;
  const BankDFromIndex = headerData.indexOf("AccountHolderName") + 1;

  const billingA = mergedColumns.slice(AddFromIndex, AddFromIndex + 10);
  const shippingA = mergedColumns.slice(AddFromIndex + 10, AddFromIndex + 20);
  const payTerms = mergedColumns.slice(
    PayTermsFromIndex,
    PayTermsFromIndex + 2
  );
  const contactInfo = mergedColumns.slice(NameFromIndex, PayTermsFromIndex + 8);
  const BusinessDetail = mergedColumns.slice(
    BusinessDFromIndex,
    BusinessDFromIndex + 15
  );
  const BankDetail = mergedColumns.slice(BankDFromIndex, BankDFromIndex + 9);

  // Please don’t change the order of the code below – it matters.
  mergedColumns.splice(BankDFromIndex, 9, {
    title: "Bank Detail",
    children: BankDetail,
  });
  mergedColumns.splice(BusinessDFromIndex, 15, {
    title: "Business Detail",
    children: BusinessDetail,
  });
  mergedColumns.splice(NameFromIndex, 6, {
    title: "Contact Information",
    children: contactInfo,
  });
  mergedColumns.splice(PayTermsFromIndex, 2, {
    title: "Pay Terms",
    children: payTerms,
  });
  mergedColumns.splice(AddFromIndex, 10, {
    title: "Billing Address",
    children: billingA,
  });
  mergedColumns.splice(AddFromIndex + 1, 10, {
    title: "Shipping Address",
    children: shippingA,
  });

  const handleSaveAll = async () => {
    try {
      form.validateFields().then((values) => {
        setLoad(true);
        if (values) {
          const formattedData = Object.entries(values?.list).map(
            ([_, values]) => values
          );
          const finalVal = formattedData?.map((item: any) => {
            let bankDetail: any = [];
            let addressDetail: any = [];
            let payTerm = null;
            let contactInformation: any = [];

            if (
              item?.Parent_Group.label ===
                "Trade Payables - Sundry Creditors" ||
              item?.Parent_Group.label === "Trade Receivables - Sundry Debtors"
            ) {
              bankDetail = [
                {
                  // ledgerName: item?.BankLedgerName,
                  uPIId: item?.UPIId,
                  accountHolderName: item?.AccountHolderName,
                  accountNumber: item?.AccountNumber,
                  accountType:
                    item?.AccountType === BankAccountTypes.All
                      ? BankAccountTypes.SavingAccount
                      : BankAccountTypes[item?.AccountType],
                  bankName: item?.BankName,
                  iFSCode: item?.IFSCode,
                  branch: item?.Branch,
                  oDLimit: item?.ODLimit,
                  isDefault: item?.BankIsDefault,
                },
              ];
              addressDetail = [
                (Object.hasOwn(item, "Add1Name") && item?.Add1Name !== null) ||
                undefined
                  ? {
                      type: TypeOfAddress[item.Add1Type],
                      addressName: item.Add1Name,
                      address: {
                        building: item?.Add1Building,
                        street: item?.Add1Street,
                        landMark: item?.Add1Landmark,
                        city: item?.Add1City,
                        district: item?.Add1District,
                        pincode: item?.Add1Pincode,
                        state: item?.Add1State,
                        // state1: item?.Add1State,
                        country: item?.Add1Country,
                      },
                    }
                  : null,
                (Object.hasOwn(item, "Add2AddressName") &&
                  item?.Add2AddressName !== null) ||
                undefined
                  ? {
                      type: TypeOfAddress[item?.Add2Type],
                      addressName: item?.Add2AddressName,
                      address: {
                        building: item?.Add2Building,
                        street: item?.Add2Street,
                        landMark: item?.Add2Landmark,
                        city: item?.Add2City,
                        district: item?.Add2District,
                        pincode: item?.Add2Pincode,
                        state: item?.Add2State,
                        // state2: item?.Add2State,

                        country: item?.Add2Country,
                      },
                    }
                  : null,
              ];
              // console.log("addressDetail =>", addressDetail);

              payTerm = {
                creditPeriod: item?.CreditPeriod,
                creditLimit: item?.CreditLimit,
              };
              contactInformation = [
                {
                  name: item?.Name,
                  designation: item?.Designation,
                  phone: item?.Phone,
                  email: item?.Email,
                  cCTo: item?.CCTo,
                  isDefault: item?.IsDefault,
                },
              ];
            } else if (item?.Parent_Group === "Bank Account") {
              bankDetail = [
                {
                  // ledgerName: item?.BankLedgerName,
                  uPIId: item?.UPIId,
                  accountHolderName: item?.AccountHolderName,
                  accountNumber: item?.AccountNumber,
                  accountType: BankAccountTypes[item?.AccountType],
                  bankName: item?.BankName,
                  iFSCode: item?.IFSCode,
                  branch: item?.Branch,
                  oDLimit: item?.ODLimit,
                  isDefault: item?.BankIsDefault,
                },
              ];
            }
            // let Duty = null;
            // if (
            //   item?.Parent_Group === "Duties & Taxes - GST" ||
            //   "Duties & Taxes - Income Tax"
            // ) {
            //   Duty = {
            //     typeOfDuty: Duty_Type[item?.TypeOfDuty],
            //     gSTTaxType: GSTTax_Type[item?.GSTTaxType],
            //     gSTRate:
            //       item?.GSTRate === "Exempt" || "Nil" || "0" ? 0 : item?.GSTRate,
            //   };
            // }
            // setData(finalVal);
            return {
              parent: item?.Parent_Group?.value,
              LedgerName: item?.LedgerName,
              AliasName: item?.AliasName,
              bankDetail: bankDetail?.length > 0 ? bankDetail : null,
              contactInformation: contactInformation?.length
                ? contactInformation
                : null,
              addresses:
                addressDetail?.length > 0
                  ? addressDetail.filter(
                      (address: any) =>
                        address.addressName && address.address.state
                    )
                  : null,
              payTerm: payTerm,
              partyType:
                item?.GSTType === CompanyGSTTypes.Consumer
                  ? PartyType.IndividualPerson
                  : PartyType.CompanyFirm,
              businessType: BusinessTypes[item?.BusinessType],
              businessNature: item?.BusinessNature
                ? [BusinessNatures[item?.BusinessNature]]
                : [],
              msmeNo: item?.MSMENo,
              state: item?.State
                ? item?.State
                : addressDetail[0]?.address?.state
                ? addressDetail[0]?.address?.state
                : currentClient?.state,
              website: item?.Website,
              partyDisRate: item?.PartyDisRate,
              isTransporter: item?.IsTransporter,
              tcsCollecteeType: DeducteeTypes[item?.TCSCollecteeType],
              ledgerTCSApplicability: item?.LedgerTCSApplicability,
              deductTDSinSameVoucher: item?.DeductTDSinSameVoucher,
              tdsDeducteeType: DeducteeTypes[item?.TDSDeducteeType],
              tdsDeductible: item?.TDSDeductible,
              iEC: item?.IEC,
              tAN: item?.TAN,
              pAN: item?.PAN,
              gstin: item?.GSTIN,
              gstType: item?.GSTType ? item?.GSTType : CompanyGSTTypes.Consumer,
            };
          });
          console.log("finalVal from handle save : ", finalVal);
          const ledgerCount = finalVal.filter(
            (item: any) => item.LedgerName
          ).length;
          setLedgerCount(ledgerCount);
          LedgerService.ImportLedgers(currentClient?.id, finalVal).then(
            (res: any) => {
              if (res.status) {
                message.success("Ledger(s) imported sucessfully");
                setResult(res?.result);
                setLoad(false);

                if (!(location.pathname.split("/")[5] === "parties")) {
                  props?.setImportedPartyList(
                    res?.result?.map((led: any) => ({
                      id: led?.ledgerId,
                      name: led?.ledgerName,
                    }))
                  );
                }

                const den = res?.result.filter(
                  (item: any) => item.added === 2
                ).length;
                const add = res?.result.filter(
                  (item: any) => item.added === 0
                ).length;

                const exi = res?.result.filter(
                  (item: any) => item.added === 1
                ).length;

                setDenLedName(den);
                setAddLedName(add);
                setExiLedName(exi);
              } else {
                message.error(res?.message);
                setLoad(false);
              }
            }
          );
        }
      });
    } catch (error) {
      console.error("Validation failed:", error);
      setLoad(false);
    }
  };

  const setFormValues = (formattedData: any[]) => {
    const listValues: Record<string, any> = {};

    formattedData.forEach((item) => {
      const rowKey = item.key;
      listValues[rowKey] = {
        ...item,
        Add1State: item.Add1State
          ? Utils.getNumber((item?.Add1State as string)?.split("-")[0]?.trim())
          : currentClient?.state,
        Add2State: item.Add2State
          ? Utils.getNumber((item?.Add2State as string)?.split("-")[0]?.trim())
          : currentClient?.state,
        Add1Country: item?.Add1Country ? item?.Add1Country : "INDIA",
        Add2Country: item?.Add2Country ? item?.Add2Country : "INDIA",
        State: item?.State
          ? Utils.getNumber((item?.State as string)?.split("-")[0]?.trim())
          : currentClient?.state,
        Parent_Group: { label: item?.Parent_Group, value: item?.Parent_Id },
        GSTType: item?.GSTType
          ? CompanyGSTTypes[item?.GSTType]
          : CompanyGSTTypes.Unregistered,
      };
      setGSTTypeValue((prev: any) => ({
        ...prev,
        [rowKey]: {
          GSTType: item?.GSTType
            ? CompanyGSTTypes[item.GSTType]
            : CompanyGSTTypes.Unregistered,
        },
      }));
    });

    form.setFieldsValue({
      list: listValues,
    });
  };
  const handleBeforeUpload = (file: File) => {
    const reader = new FileReader();
    form.resetFields();
    reader.onload = (e) => {
      const binaryStr = e.target?.result as string;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Convert sheet to JSON where headers are used as keys
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
      }) as any[][];

      if (jsonData.length > 0) {
        // Extract header row
        const header = jsonData[2];
        const showheader = jsonData[3];
        const dataArray = jsonData.slice(4); // Data rows
        const rowsArray = dataArray.filter(
          (r) => r[0] !== "" && r[0] !== null && r[0] !== undefined
        ); // Data rows
        console.log("DAta: ", rowsArray);

        // Convert rowsArray to array of objects with column headers as keys
        const formattedData: ParsedDataType[] = rowsArray.map(
          (row, rowIndex) => {
            const obj = row.reduce((acc, value, index) => {
              acc[header[index]] = value;
              return acc;
            }, {} as ParsedDataType);

            return {
              ...obj,
              key: `${rowIndex}`,
            };
          }
        );

        setHeaderData(header);
        setFormValues(formattedData);
        setForData(formattedData);
        setShowHeaderData(
          showheader?.filter((field: string) => field !== "Parent_Id")
        );
        console.log("formattedData", formattedData);
      }
    };
    reader.readAsArrayBuffer(file);
    return false;
  };
  return (
    <div>
      <Modal
        width={1400}
        // open={open}
        open
        title="Party Transaction"
        onCancel={() => props.onCancel()}
        footer={
          <div style={{ marginTop: "0px" }}>
            <Button onClick={() => props.onCancel()}>Close</Button>
          </div>
        }
      >
        <Row
          gutter={20}
          style={{ justifyContent: "space-between", padding: "15px" }}
        >
          <Col span={7} className="card">
            <p
              style={{
                fontSize: "15px",
                paddingTop: "1px",
                color: "black",
                fontWeight: "bold",
              }}
            >
              Step 1. Download our ledger master template file.
            </p>
            <p
              style={{
                paddingTop: "10px",
                lineHeight: "1.4rem",
                color: "black",
              }}
            >
              You can download our XLSX ledger master template file. The file
              has got accurate prescribed headings which are to be imported.
            </p>
            <p
              style={{
                color: "blue",
                cursor: "pointer",
                paddingTop: "5px",
              }}
              onClick={handleDownload}
            >
              <span>
                <DownloadOutlined /> Download Template
              </span>
            </p>
          </Col>
          <Col span={7} className="card" style={{ margin: "0px 10px" }}>
            <p
              style={{
                fontSize: "15px",
                paddingTop: "1px",
                color: "black",
                fontWeight: "bold",
              }}
            >
              Step 2. Copy Data into template file.
            </p>
            <p
              style={{
                paddingTop: "10px",
                height: "100%",
                lineHeight: "1.4rem",
                color: "black",
              }}
            >
              You can copy your data into the template file using excel or any
              other spreadsheet editor. Make sure the ledger master data you
              copied, matches the column headings provided in the template.
              Headings are not changeable.
            </p>
          </Col>
          <Col span={7} className="card">
            <p
              style={{
                fontSize: "15px",
                paddingTop: "1px",
                color: "black",
                fontWeight: "bold",
              }}
            >
              Step 3. Import the filled template file.
            </p>
            <p
              style={{
                paddingTop: "10px",
                height: "100%",
                lineHeight: "1.4rem",
                color: "black",
              }}
            >
              <Upload
                //   {...Props}
                accept=".xlsx"
                showUploadList={false}
                beforeUpload={handleBeforeUpload}
              >
                <Button
                  //   disabled={load}
                  icon={<UploadOutlined />}
                  type="primary"
                >
                  Import
                </Button>
              </Upload>
            </p>
          </Col>
        </Row>

        <div style={{ marginTop: "20px" }}>
          {forData?.length < 1 ? (
            <>
              <p
                style={{
                  padding: "5px 10px 5px 5px",
                  // boxShadow: " 0 2px 6px rgba(0, 0, 0, 0.1)",
                  // width: "auto",
                  fontSize: "16px",
                  // borderRadius: "5px",
                  fontStyle: "oblique",
                }}
              >
                <u>Available Fields</u>
              </p>
              <Table
                bordered
                pagination={false}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                size="small"
                columns={columns}
                dataSource={dataSource}
                scroll={{ y: window.innerHeight - 600 }}
              />
            </>
          ) : (
            <>
              <Spin indicator={antIcon} spinning={load}>
                <Form
                  form={form}
                  name=""
                  colon={false}
                  requiredMark={true}
                  disabled={ledgerCount != 0 && ledgerCount === addLedName}
                  autoComplete="off"
                  layout="vertical"
                >
                  <Table
                    bordered
                    pagination={false}
                    components={{ body: { cell: EditableCell } }}
                    className={`Tabel-style table-${
                      themeData?.componentSize ?? "middle"
                    }`}
                    size="small"
                    columns={mergedColumns}
                    dataSource={forData}
                    // scroll={{ y: window.innerHeight - 600 }}
                    rowClassName="editable-row"
                    style={{ width: "100%" }}
                    scroll={{ x: "max-content" }}
                  />
                </Form>
              </Spin>

              <Button
                onClick={handleSaveAll}
                type="primary"
                style={{ marginBottom: 16 }}
                loading={load}
              >
                Save
              </Button>

              <div style={{ marginTop: "20px" }}>
                <div
                  style={{
                    marginTop: "20px",
                    // background: "#f9f9f9",
                    padding: "16px",
                    // borderRadius: "8px",
                    // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Row gutter={[16, 16]} justify="space-between" align="middle">
                    <Col>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "16px",
                          color: "#1890ff",
                        }}
                      >
                        Total Ledgers Imported:
                      </span>
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "16px",
                          color: "#333",
                        }}
                      >
                        {ledgerCount}
                      </span>
                    </Col>
                    <Col>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "16px",
                          color: "#52c41a",
                        }}
                      >
                        Imported Ledgers:
                      </span>
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "16px",
                          color: "#333",
                        }}
                      >
                        {addLedName}
                      </span>
                    </Col>
                    <Col>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "16px",
                          color: "#faad14",
                        }}
                      >
                        Existed Ledgers:
                      </span>
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "16px",
                          color: "#333",
                        }}
                      >
                        {exiLedName}
                      </span>
                    </Col>
                    <Col>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "16px",
                          color: "#b80000",
                        }}
                      >
                        Denied Ledgers:
                      </span>
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "16px",
                          color: "#333",
                        }}
                      >
                        {denLedName}
                      </span>
                    </Col>
                  </Row>
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ImportPartyModal;
